export const digitsOnly = (value?: string | null): string => value?.replace(/\D/g, '') ?? '';

export const buildTelHref = (value?: string | null): string => {
  const digits = digitsOnly(value);
  return digits ? `tel:+${digits}` : '';
};

export const buildWhatsAppUrl = (value?: string | null, message?: string): string => {
  const digits = digitsOnly(value);
  if (!digits) return '';

  if (!message) {
    return `https://wa.me/${digits}`;
  }

  return `https://wa.me/${digits}?text=${encodeURIComponent(message)}`;
};
